import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../Icon';
var InboxDownloadSvg = function InboxDownloadSvg() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m12.698 8.86 2.53-2.5.986.974L12 11.5 7.786 7.334l.986-.975 2.53 2.5V2.25h1.396z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M2 12.594h7.442v1.609a2.5 2.5 0 0 0 .75 1.788 2.56 2.56 0 0 0 1.808.74 2.58 2.58 0 0 0 1.809-.74 2.53 2.53 0 0 0 .75-1.788v-1.61H22v9.656H2zm1.395 1.38v6.896h17.21v-6.897h-4.651v.23a3.903 3.903 0 0 1-1.158 2.764 3.993 3.993 0 0 1-5.591 0 3.9 3.9 0 0 1-.858-1.268 3.9 3.9 0 0 1-.3-1.496v-.23z",
    clipRule: "evenodd"
  }));
};
export var InboxDownload = function InboxDownload(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    component: InboxDownloadSvg
  }));
};